import React, {useContext, useState} from 'react';
import {FormProvider} from 'react-hook-form';
import {ModalContext} from '@igp/shared/components/modal';

import {useAdjustDebtForm} from '../hooks';

import {AdjustDebtConfiramtion} from './AdjustDebtConfirmation';
import {AdjustDebtForm} from './AdjustDebtForm';

export function AdjustDebtModal() {
    const {closeModal} = useContext(ModalContext);
    const {state, submit, ...form} = useAdjustDebtForm({
        onSuccess: closeModal,
    });
    const [currentStep, setCurrentStep] = useState<'form' | 'confirmation'>('form');
    const {handleSubmit} = form;
    return (
        <FormProvider {...form}>
            {currentStep === 'form' ? (
                <AdjustDebtForm onCancel={closeModal} onSubmit={() => setCurrentStep('confirmation')} />
            ) : (
                <AdjustDebtConfiramtion
                    onSubmit={handleSubmit(submit)}
                    onBack={() => {
                        state.resetAsyncActionState();
                        setCurrentStep('form');
                    }}
                    isProgress={state.isProgress}
                    isError={state.isError}
                />
            )}
        </FormProvider>
    );
}
